'use client';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { useReporter } from '../../reporter';
import { PupInfoForm } from '../PupInfoForm';
import { ScreeningStepHeader } from '../ScreeningStepHeader';
import {
  HealthScreeningContextActionName,
  useHealthScreening,
} from '../HealthScreeningContainer/context';
import { userCompletesPupForm, viewPupInfoPageEvent } from './events';
import { StyledPupInfoFormContainer } from './styles';

export const PupInfoFormContainer = ({
  stepTitle,
  stepDescription,
  headerImage,
  form,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { pet, dispatch } = useHealthScreening();
  const router = useRouter();
  const reporter = useReporter();

  useEffect(() => {
    reporter.tag(viewPupInfoPageEvent());
  }, [reporter]);

  const handleSubmit = async pet => {
    setIsSubmitting(true);
    dispatch({
      type: HealthScreeningContextActionName.setPet,
      payload: pet,
    });
    reporter.tag(userCompletesPupForm(pet));
    router.push({ pathname: `/health/weight/photo` });
  };

  return (
    <StyledPupInfoFormContainer>
      <ScreeningStepHeader
        title={stepTitle}
        description={stepDescription}
        image={headerImage}
      />
      <PupInfoForm
        {...form}
        stepTitle={stepTitle}
        stepDescription={stepDescription}
        headerImage={headerImage}
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
        defaultValues={pet}
      />
    </StyledPupInfoFormContainer>
  );
};

PupInfoFormContainer.displayName = 'PupInfoFormContainer';
PupInfoFormContainer.propTypes = {
  stepTitle: PropTypes.string,
  stepDescription: PropTypes.string,
  headerImage: PropTypes.object,
  form: PropTypes.shape({
    labelName: PropTypes.string.isRequired,
    labelBirthMonth: PropTypes.string.isRequired,
    labelBirthYear: PropTypes.string.isRequired,
    birthInfoFootnote: PropTypes.string.isRequired,
    labelActivityLevel: PropTypes.string.isRequired,
    noSelectionLabel: PropTypes.string.isRequired,
    activityLevels: PropTypes.array.isRequired,
    weightLabel: PropTypes.string.isRequired,
    labelNeutered: PropTypes.string.isRequired,
    neutered: PropTypes.array.isRequired,
    submitButtonText: PropTypes.string.isRequired,
    submitButtonVariant: PropTypes.string.isRequired,
  }).isRequired,
};
